import wixApplication from 'wix-application';
import { viewMode } from 'wix-window';


$w.onReady(async () => {
    // Initialize your widget here. If your widget has properties, this is a good place to read their values and initialize the widget accordingly.
    let instance = await wixApplication.getDecodedAppInstance();
    console.log(viewMode) 
    const instanceId=instance.instanceId;
    $w('#customElement2').setAttribute('instanceId', instanceId);
    $w('#customElement2').setAttribute('viewMode', viewMode);
    
});

$widget.onPropsChanged((oldProps, newProps) => {
 

});